<template>
  <h4>List Komparator</h4>
  <komparator></komparator>
</template>

<script>
import komparator from './components/Komparator.vue'

export default {
  name: 'App',
  components: {
    komparator
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
